<!--
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
-->
<!--
  Program: Top menu
  Author: SDL
  Brief: top menu common layout
-->
<template>
  <header class="container-fluid fixed-top navbar-dark bg-img" v-if="isLoaderVisible">
    <nav class="navbar navbar-expand-lg justify-content-between ui--top">
      <!-- brand -->
      <!-- <router-link :to="{ name: 'mainIndexPage' }" class="navbar-brand cursor-pointer" href="javascript:">
        <img
          :src="$CONTEXT + '/static/image/main/simbol.png'"
          class="ui--brand-simbol"
          :alt="$t('sdl.common.projectName')"
        />
        <span class="brand-text">{{ $t('sdl.common.projectName') }}</span>
      </router-link> -->
      <!-- menu -->

      <ul class="navbar-nav">
        <li class="nav-item dropdown" v-for="menu in rootMenus" :key="menu.menuId" :index="menu.menuId">
          <a
            class="nav-link dropdown-toggle"
            href="javascript:"
            data-toggle="dropdown"
            @click="openExternalUrl(menu.externalUrlUsed, menu.externalUrl, $event)"
          >
            {{ getLabel(menu) }} <i class="material-icons ui--menu-icon-1" v-show="menu.externalUrlUsed">open_in_new</i>
          </a>
          <!--          <a class="nav-link dropdown-toggle" href="javascript:" data-toggle="dropdown">{{ menu.localeLabel }}</a>-->
          <!-- dropdown-menu  -->
          <div
            class="dropdown-menu text-center-test"
            v-if="menu.externalUrlUsed === false"
            :class="{ 'text-center': getSubmenu(menu.menuId).length > subMenuLimitCnt }"
          >
            <ul class="dropdown-item">
              <li v-for="submenu in getSubmenu(menu.menuId)" :key="submenu.menuId" :index="submenu.menuId">
                <strong v-if="submenu.externalUrlUsed === true">
                  <a href="javascript:" @click="openExternalUrl(submenu.externalUrlUsed, submenu.externalUrl)">
                    {{ getLabel(submenu) }} <i class="material-icons ui--menu-icon-2">open_in_new</i>
                  </a>
                </strong>
                <strong v-else-if="submenu.defaultPage">
                  <a href="javascript:" @click="moveMenu(submenu.defaultPage.pagePath)">
                    {{ getLabel(submenu) }} <i class="material-icons ui--menu-icon-2">arrow_forward_ios</i>
                  </a>
                </strong>
                <strong v-else>{{ getLabel(submenu) }}</strong>
                <ul>
                  <li v-for="item in getSubmenu(submenu.menuId)" :key="item.menuId" :index="item.menuId">
                    <a
                      v-if="item.externalUrlUsed"
                      href="javascript:"
                      @click="openExternalUrl(item.externalUrlUsed, item.externalUrl)"
                    >
                      {{ getLabel(item) }}
                      <i class="material-icons ui--menu-icon-3">open_in_new</i>
                    </a>
                    <a v-else href="javascript:" @click="moveMenu(item.menuUrl)">
                      {{ getLabel(item) }}
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <!-- right menu -->
      <div class="right-container">
        <span class="ui--confidential float-right">Confidential</span>
        <a href="javascript:void(0)" class="float-right mr-3 ui--nav-notice ui--notice-on" @click="toggleNoticeArea">
          <i class="material-icons">notifications</i><span class="badge badge-danger" v-if="newNoticeCount > 0">{{ newNoticeCount }}</span>
        </a>
        <div class="ui--notice ui--notice-position" v-show="showNoticeArea">
          <h5>
            {{ $t('sdl.main.message.notice') }}
            <button type="button" class="close" @click="toggleNoticeArea"><i class="material-icons">close</i></button>
          </h5>
          <div class="ui--notice-row">
            <div class="ui--notice-list">
              <a
                href="javascript:void(0)"
                v-for="notice in noticeList"
                :key="notice.postId"
                :class="{ active: selectedNotice.postId === notice.postId, notread: !notice.noticeChecked }"
                @click="selectNotice(notice)"
              >
                {{ notice.postTitle }}
              </a>
            </div>
            <div class="ui--notice-contents">
              <div class="in-board" v-html="$options.filters.nl2br(selectedNotice.postDetail)"></div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import axios from 'axios';
import store from '@/vuex/store';
import SDLLocale from '@/mixin/SDLLocale';
import { SDLUtil, StringUtil } from '@/utils';

export default {
  name: 'TopMenu',
  mixins: [SDLLocale],
  data() {
    return {
      showNoticeArea: false,
      noticeList: [],
      readNoticeList: [],
      selectedNotice: {},
      subMenuLimitCnt: 4,
      isLoaderVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      menus: 'getMenus', // Receive menus with getter
    }),
    rootMenus() {
      return _.sortBy(this.menus.filter(menu => menu.menuLevel === 1 && menu.menuId !== 'COMM_URL'), ['menuSequence']);
    },
    newNoticeCount() {
      return this.noticeList.filter(notice => !notice.noticeChecked).length;
    },
  },
  watch: {
    $route() {
      this.showNoticeArea = false;
      this.getNoticeList();
    },
  },
  methods: {
    setSubMenuStyle() {
      // Use setTimeout to process after ui rendering
      setTimeout(() => {
        const cssSelector = 'header > nav > ul > li.nav-item.dropdown.show';
        const openMenu = document.querySelector(cssSelector);
        // console.info('openMenu', openMenu);
        if (openMenu && !openMenu.querySelector('.text-center')) {
          const marginLeft = 12;
          const ulMarginLeft = openMenu.offsetLeft + marginLeft;
          document
            .querySelector(`${cssSelector} ul.dropdown-item`)
            .setAttribute('style', `margin-left: ${ulMarginLeft}px`);
        }
      });
    },
    getSubmenu(parentId) {
      return _.sortBy(this.menus.filter(menu => menu.parentId === parentId), ['menuSequence']);
    },
    moveMenu(pagePath) {
      // Initialize saved parameters when forced to move from the menu
      store.commit('PARAMS', {});
      this.$router.push({ path: pagePath });
      // If the moving component is the same, refresh is required
      const fromComponentName = this.$route.meta.componentName;
      const toMenu = _.find(this.menus, ['menuUrl', pagePath]);
      if (fromComponentName === toMenu.componentName) {
        this.$emit('router-reload');
      }
    },
    openExternalUrl(isExternal, url, event) {
      if (isExternal) {
        window.open(url.startsWith('http') ? url : `http://${url}`, '_blank');
        if (event) {
          const { parentElement } = event.target;
          // Remove selected class
          setTimeout(() => {
            parentElement.classList.remove('show');
          });
        }
      }
    },
    // Retrieving Notice List
    getNoticeList() {
      SDLUtil.showLoadingBar(true);
      axios
        .get(`${SDLUtil.API_URL}/notice-popup-posts`)
        .then(({ data }) => {
          if (!_.isEmpty(data)) this.noticeList = data;
        })
        .catch(err => {
          SDLUtil.showLoadingBar(false);
          SDLUtil.errorAlert(err);
        });
      SDLUtil.showLoadingBar(false);
    },
    // View Notice Details
    selectNotice(notice) {
      if (!notice.noticeChecked) {
        const params = { postId: notice.postId, userId: SDLUtil.getLoginedUserInfo().userId };
        SDLUtil.showLoadingBar(true);
        axios
          .post(`${SDLUtil.API_URL}/check-notice?${StringUtil.queryStringfy(params)}`)
          .then(() => {
            this.selectedNotice = notice;
            this.getNoticeList();
          })
          .catch(err => {
            SDLUtil.showLoadingBar(false);
            SDLUtil.errorAlert(err);
          });
        SDLUtil.showLoadingBar(false);
      } else {
        this.selectedNotice = notice;
      }
    },
    // Notice area show / hide
    toggleNoticeArea() {
      this.showNoticeArea = !this.showNoticeArea;
      if (this.showNoticeArea && !_.isEmpty(this.noticeList)) {
        this.selectNotice(_.first(this.noticeList));
      }
    },
  },
  created() {
    // document.querySelector('body').classList.remove('sdl-wrap', 'ui--login-wrap');
    if (document.querySelector('body').classList.contains('ui--login-wrap')) {
      document.querySelector('body').classList.remove('ui--login-wrap');
    }
    if (document.querySelector('body').classList.contains('sdl-wrap')) {
      document.querySelector('body').classList.remove('sdl-wrap');
    }
    this.getNoticeList();
    if (document.location.origin.indexOf('localhost') > 0) {
      this.isLoaderVisible = true;
    }
  },
  mounted() {
    this.$nextTick(() => {
      // resize event
      window.onresize = _.debounce(() => {
        this.setSubMenuStyle();
      }, 100);

      // ref. https://getbootstrap.com/docs/4.0/components/dropdowns/#events
      $('li.nav-item.dropdown').on('show.bs.dropdown', () => {
        this.setSubMenuStyle();
      });
    });
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/admin/main/MainTopMenu.vue